export default {
  namespaced: true,
  training: {
    title: "Training",
    training_topic: "Training Topics",
    number_of_guests: "Number of guests",
    number_of_attendees: "Number of attendees",
    cost: "Cost",
    supplier_name: "Supplier name",
    add_training: "Add Training",
    center: "Center",
    sector: "Sector",
    region: "Regipn",
    type: "Type",
    mode: "Mode",
    confirm_cancel: "¿Are you sure you want to cancel this training?",
    canceled: "Training canceled",
  }
};
